import { FC, ReactNode, useMemo } from 'react';
import { useTranslations } from 'hooks/useTranslations';
import { footerLinksConstruction, footerLinksHusqvarna } from 'utils/constants';
import husqvarnaGroupLogo from 'assets/vectors/hq-logo-group.svg';
import { isConstruction } from 'config';
import {
  Footer,
  Logo,
  Text,
  Content,
  Links,
  InternalLink,
  ExternalLink
} from './styled';

type Props = {
  children: ReactNode;
  fullHeight?: boolean;
};

const Copyright: FC<Props> = ({ children, fullHeight = false }) => {
  const t = useTranslations();

  const footerLinks = useMemo(
    () => (isConstruction ? footerLinksConstruction : footerLinksHusqvarna),
    []
  );

  return (
    <>
      <Content $fullHeight={fullHeight}>{children}</Content>
      <Footer>
        <Logo src={husqvarnaGroupLogo} alt="husqvarna group" />
        <Text>{t('login.hq_group_text')}</Text>
        <Links>
          {footerLinks.map(({ link, type, name }) => {
            if (type === 'internal') {
              return (
                <InternalLink key={name} to={link}>
                  {t(name)}
                </InternalLink>
              );
            }
            return (
              <ExternalLink
                key={name}
                href={link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t(name)}
              </ExternalLink>
            );
          })}
        </Links>
      </Footer>
    </>
  );
};

export default Copyright;
